import { AppModule } from "../app/app.module";
import { LoadingProvider } from "../providers/loading/loading";
import { AlertProvider } from "../providers/alert/alert";
import { NavController, NavParams, ViewController, Platform } from "ionic-angular";
import { TranslateService } from "@ngx-translate/core";
import { AppConfig } from "../config/app.config";

export class PageBase {
    loadingProvider = AppModule.injector.get(LoadingProvider);
    alertProvider = AppModule.injector.get(AlertProvider);
    appConfig = AppModule.injector.get(AppConfig);
    translate = AppModule.injector.get(TranslateService);
    platform = AppModule.injector.get(Platform);


    constructor(){
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/page-base.ts